<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Associação de {{entityPlural}}</p>
        </div>

        <div class="muven-content">
            <Breadcrumb :items="breadcrumbList" class="mb-3" v-if="!loading"/>

            <Loading page v-if="loading" message="Obtendo informações do canal, isso pode demorar um pouco..." />

            <div class="muven-card filter-form-container" v-if="!loading">
                <div class="">
                    <div class="d-inline-block">
                        <label>{{ supportsRemoteSearch ? 'Buscar categoria no canal' : 'Filtrar por descrição' }}</label>
                        <div :class="{ 'd-flex': supportsRemoteSearch }">
                            <input type="text"
                                class="form-control"
                                :placeholder="supportsRemoteSearch ? 'Digite um termo e tecle Enter' : ''"
                                @keyup.enter="searchInChannel"
                                v-model="filterForm.description">
                            <button v-if="supportsRemoteSearch"
                                type="button"
                                class="btn btn-secondary ml-2 text-nowrap"
                                :disabled="searching"
                                @click="searchInChannel">
                                {{ searching ? 'Buscando...' : 'Buscar' }}
                            </button>
                        </div>
                    </div>
                    <div class="d-inline-block ml-5">
                        <label>Filtrar por status de ativação</label>
                        <div class="btn-group">
                            <button type="button" 
                                class="btn"
                                v-for="(filterInfo, index) in filterByActivationStatus" :key="index"
                                :class="{
                                    'btn-outline-secondary': !filterForm.isFilterByActivationActive(filterInfo),
                                    'btn-secondary': filterForm.isFilterByActivationActive(filterInfo),
                                }"
                                @click="filterForm.setFilterByActivationStatus(filterInfo)">
                                {{filterInfo.description}}
                            </button>
                        </div>
                    </div>
                    <div class="d-inline-block ml-5" v-show="allowExportEnabled">
                        <label class="hidden">Filtrar por status de exportação</label>
                        <div class="btn-group">
                            <button type="button" 
                                v-for="(filterInfo, index) in filterByExportStatus" :key="index"
                                class="btn"
                                :class="{
                                    'btn-outline-secondary': !filterForm.isFilterByExportActive(filterInfo),
                                    'btn-secondary': filterForm.isFilterByExportActive(filterInfo),
                                }"
                                @click="filterForm.setFilterByExportStatus(filterInfo)">
                                {{filterInfo.description}}
                            </button>
                        </div>

                    </div>
                </div>
            </div>

            <div class="muven-card" v-if="!loading && supportsRemoteSearch && !listChannel.length">
                <div class="">
                    <p>Digite o nome do produto ou categoria e clique em <strong>Buscar</strong> para localizar as categorias do canal.</p>
                </div>
            </div>

            <div class="muven-card" v-if="!loading && !(supportsRemoteSearch && !listChannel.length) && !filteredAssociationList.length">
                <div class="">
                    <p>Nada encontrado com o filtro:</p>
                    <ul>
                        <li class="mb-2 mt-2">
                            <span class="text-muted">Descrição:</span> 
                            <span class="ml-3">{{filterForm.description | infoOrPlaceholder}}</span>
                        </li>
                        <li class="mb-2">
                            <span class="text-muted">Status de ativação:</span> 
                            <span class="ml-3">{{filterForm.activationStatus.description}}</span>
                        </li>
                        <li>
                            <span class="text-muted">Status de exportação:</span> 
                            <span class="ml-3">{{filterForm.exportStatus.description}}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="muven-card muven-card-table-like" v-if="!loading && !!filteredAssociationList.length">
                <div class="muven-card-thead">
                    <div class="row muven-card-tr">
                        <div class="col-3 muven-card-td">
                            <label>No canal</label>
                        </div>
                        <div class="col-4 muven-card-td">
                            <label>Na retaguarda</label>
                        </div>
                        <div class="col-1 muven-card-td text-center">
                            <label>Ativo</label>
                        </div>
                        <div class="col-2 muven-card-td text-center" v-show="allowExportEnabled">
                            <label>Exportar canal</label>
                        </div>
                        <div class="offset-2" v-show="!allowExportEnabled"></div>
                        <div class="col-2 pull-right muven-card-td text-center">
                            <label>Ações</label>
                        </div>
                    </div>
                </div>

                <div class="muven-card-tbody">
                    <div v-for="(ass, index) in filteredAssociationList" :key="index" class="row muven-card-tr">
                        <div class="col-3 muven-card-td">
                            <p>{{ass.description}}</p>
                        </div>
                        <div class="col-4 muven-card-td">
                            <p v-if="!ass.isBeingModified">{{ass.getBackendOptionDescription() | infoOrPlaceholder}}</p>

                            <SelectWrapperCmp 
                                v-if="ass.isBeingModified"
                                :show-remove-button="!!ass.backendOption.description"
                                @removed="handleAssociationRemoval(ass)">

                                <template v-slot:select>
                                    <multiselect
                                        v-model="ass.backendOption"
                                        :options="ass.availableOptions"
                                        :multiple="false"
                                        :show-labels="false"
                                        :disabled="ass.isBeingSaved"
                                        label="description"
                                        track-by="idMuven"
                                        placeholder="" />
                                </template>
                            </SelectWrapperCmp>
                        </div>
                        <div class="col-1 muven-card-td text-center">
                            <p v-if="!ass.isBeingModified">
                                <span v-show="ass.isActive">Sim</span>
                                <span v-show="!ass.isActive">Não</span>
                            </p>

                            <input type="checkbox"
                                class="mt-2" 
                                v-if="ass.isBeingModified"
                                :disabled="ass.isBeingSaved"
                                v-model="ass.isActive" />
                        </div>
                        <div class="col-2 muven-card-td text-center" v-show="allowExportEnabled">
                            <p v-if="!ass.isBeingModified">
                                <span v-show="ass.allowExport">Sim</span>
                                <span v-show="!ass.allowExport">Não</span>
                            </p>

                            <input type="checkbox" 
                                class="mt-2" 
                                v-if="ass.isBeingModified"
                                :disabled="ass.isBeingSaved"
                                v-model="ass.allowExport" />
                        </div>
                        <div class="col-2 muven-card-td text-center" :class="{'offset-2': !allowExportEnabled}">
                            <button class="btn btn-outline-secondary"
                                v-if="!ass.isBeingModified"
                                @click="startEntityModification(ass)">
                                Editar
                            </button>

                            <button class="btn btn-outline-primary"
                                v-if="ass.isBeingModified"
                                @click="saveEntityModification(ass)"
                                :disabled="ass.isBeingSaved">
                                <span v-if="!ass.isBeingSaved">Gravar</span>
                                <Loading v-if="ass.isBeingSaved" />
                            </button>

                            <button class="btn btn-outline-secondary"
                                v-if="ass.isBeingModified"
                                :disabled="ass.isBeingSaved"
                                @click="stopEntityModification(ass)">
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { cloneDeep, uniqBy } from 'lodash'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import { BaseChannelBackendAssociation } from '@c2b/muven-commons'
import { ChannelModel } from '@/channel/models/ChannelModel'
import channelService from '@/channel/services/ChannelService'
import SelectWrapperCmp from '@/utils/components/SelectWrapperCmp'

const statusActivation = {
    All: 1,
    Active: 2,
    Inactive: 3,
}

const statusExport = {
    All: 1,
    Exportable: 2,
    NotExportable: 3,
}

class FilterForm {
    static getFilterByActivationStatus() {            
        return [
            {
                id: statusActivation.All,
                description: 'Todos',
            },
            {
                id: statusActivation.Active,
                description: 'Ativos',
            },
            {
                id: statusActivation.Inactive,
                description: 'Inativos',
            }
        ]
    }
        
    static getFilterByExportStatus() {
        return [
            {
                id: statusExport.All,
                description: 'Todos',
            },
            {
                id: statusExport.Exportable,
                description: 'Exportáveis',
            },
            {
                id: statusExport.NotExportable,
                description: 'Não exportáveis',
            },
        ]
    } 

    constructor() {
        this.description = ''
        this.activationStatus = FilterForm.getFilterByActivationStatus()[0]
        this.exportStatus = FilterForm.getFilterByExportStatus()[0]
    }

    setFilterByActivationStatus(info) {
        this.activationStatus = info
    }

    setFilterByExportStatus(info) {
        this.exportStatus = info
    }

    getDescription() {
        return this.description.toLowerCase().trim()
    }

    isActivationStatusAll() {
        return this.activationStatus.id === statusActivation.All   
    }

    isActivationStatusActive() {
        return this.activationStatus.id === statusActivation.Active   
    }

    isActivationStatusInactive() {
        return this.activationStatus.id === statusActivation.Inactive   
    }

    isExportStatusAll() {
        return this.exportStatus.id === statusExport.All
    }

    isExportStatusExportable() {
        return this.exportStatus.id === statusExport.Exportable
    }

    isExportStatusNotExportable() {
        return this.exportStatus.id === statusExport.NotExportable
    }

    isFilterByExportActive(info) {
        return this.exportStatus.id === info.id
    }

    isFilterByActivationActive(info) {
        return this.activationStatus.id === info.id
    }
}

class AssociationCacheControl {
    constructor() {
        this.beingModified = []
    }

    wasModified(ass) {
        const assFromCache = this.getAss(ass)

        if (assFromCache.getBackendOption().idMuven === ass.getBackendOption().idMuven &&
            assFromCache.allowExport === ass.allowExport &&
            assFromCache.isActive === ass.isActive) {
                for (const idFromCache of assFromCache.getBackendOption().idExternalChannelList) {
                    for (const idFromAss of assFromCache.getBackendOption().idExternalChannelList) {
                        if (assFromCache.getBackendOption().idExternalChannelList === ass.getBackendOption().idExternalChannelList) {
                            return false
                        }
                    }
                }
        }

        return true
    }

    getAss(ass) {
        return this.beingModified.find((bm) => ass.id === bm.id)
    }
    
    addOrUpdate(ass) {
        for (let i = 0; i < this.beingModified.length; i++) {
            if (this.beingModified[i].id === ass.id) {
                this.beingModified[i] = cloneDeep(ass)
                return
            }
        }

        this.beingModified.push(cloneDeep(ass))
    }

    remove(associationList, ass) {
        for (let i = 0; i < associationList.length; i++) {
            if (associationList[i].id === ass.id) {
                this.beingModified.splice(i, 1)
                break
            }
        }
    }
}

class Association {
    static sequential = 0;

    constructor(channelInfo, availableOptions, listBackend) {
        this.id = ++Association.sequential;
        this.idExternalChannelList = channelInfo.idExternalChannelList
        this.description = channelInfo.description
        this.isBeingModified = false
        this.isBeingSaved = false
        this.allowExport = channelInfo.allowExport
        this.isActive = channelInfo.isActive
        this.availableOptions = cloneDeep(uniqBy(availableOptions, 'idMuven'))
        this.backendOption = listBackend.find((b) => {
            if (Array.isArray(b.idExternalChannelList) && !!b.idExternalChannelList.length) {
                return b.idExternalChannelList.includes(channelInfo.idExternalChannelList[0])
            }
        }) || {
            idExternalChannelList: [],
        }
    }

    getBackendOption() {
        return this.backendOption || {}
    }

    hasBackendOption() {
        return !!this.getBackendOption().description
    }

    getBackendOptionDescription() {
        return this.getBackendOption().description || ''
    }
}

export default {
    name: 'ChannelBackendEntityAssociationCmp',
    props: {
        entityPlural: {
            required: true,
            type: String,
            default: "",
        },
        associationService: {
            required: true,
            type: Object,
            default: () => Object.create(null),
        },
        // This prop is needed because some associations work differently when they're one-to-one.
        // For example: When it's one to one, the idMuven should always exist in the payload when
        // saving the association. The idExternalChannelList can be removed. Also, when it's one-to-one,
        // the entity in the select component cannot be used more than once.
        oneToOne: {
            required: true,
            type: Boolean,
            default: false,
        },
        allowExportEnabled: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        SelectWrapperCmp,
    },
    data() {
        return {
            loading: true,
            searching: false,
            channel: new ChannelModel(),
            filterForm: new FilterForm(),
            associationCacheControl: new AssociationCacheControl(),
            breadcrumbList: [],
            associationList: [],
            listBackend: [],
            listChannel: [],
            filterByActivationStatus: FilterForm.getFilterByActivationStatus(),
            filterByExportStatus: FilterForm.getFilterByExportStatus(),
        }
    },
    filters: {
        infoOrPlaceholder,
    },
    methods: {
        // Busca ao vivo de categorias no canal (ML). Mescla os resultados na lista já carregada
        // (dedup por idExternalChannel) para não perder buscas/associações anteriores; o filtro
        // local (filteredAssociationList) continua atuando sobre tudo que já foi trazido.
        async searchInChannel() {
            if (!this.supportsRemoteSearch) {
                return
            }

            const term = this.filterForm.getDescription()
            if (!term) {
                this.$floatingAlert.info({
                    message: 'Digite um termo para buscar as categorias do canal.',
                })
                return
            }

            this.searching = true

            try {
                const channelId = this.$route.params.id
                const results = await this.associationService.getEntitiesInChannel(channelId, term)

                this.listChannel = uniqBy(
                    [...this.listChannel, ...results],
                    (channelInfo) => channelInfo.idExternalChannelList[0],
                )

                const availableOptions = this._filterListBackendOptions(this.listChannel, this.listBackend)
                this.associationList = this.listChannel.map((channelInfo) => {
                    return new Association(channelInfo, availableOptions, this.listBackend)
                })

                // O termo buscado (conceito do produto) normalmente não bate com o nome das categorias
                // retornadas; limpar o filtro garante que os resultados fiquem visíveis. O usuário pode
                // digitar de novo para filtrar localmente o que já foi trazido.
                this.filterForm.description = ''

                if (!results.length) {
                    this.$floatingAlert.info({
                        message: 'Nenhuma categoria encontrada no canal para esse termo.',
                    })
                }
            } catch (e) {
                this.$floatingAlert.error({
                    message: e.message,
                })
            }

            this.searching = false
        },
        handleAssociationRemoval(ass) {
            const tmp = cloneDeep(ass)
            this.associationCacheControl.addOrUpdate(tmp)
            ass.backendOption = {}
        },
        startEntityModification(ass) {            
            ass.isBeingModified = true

            if (this.oneToOne) {
                const idList = ass.availableOptions.filter((opt) => {
                    for (const idExternalChannel of opt.idExternalChannelList) {
                        return !!idExternalChannel
                    }
                })

                for (const idExternalChannel of ass.getBackendOption().idExternalChannelList) {
                    if (!idList.includes(idExternalChannel)) {
                        ass.availableOptions.unshift(cloneDeep(ass.getBackendOption()))
                    }
                }
            }

            this.associationCacheControl.addOrUpdate(ass)
        },
        stopEntityModification(ass) {
            Object.assign(ass, this.associationCacheControl.getAss(ass))
            this.associationCacheControl.remove(this.associationList, ass)
            ass.isBeingModified = false
        },
        async saveEntityModification(ass) {
            if (!this.associationCacheControl.wasModified(ass)) {
                this.$floatingAlert.hide()
                this.$floatingAlert.info({
                    message: 'Nenhuma modificação feita.',
                })

                ass.isBeingModified = false

                return
            }

            ass.isBeingSaved = true

            if (this.oneToOne) {
                await this._saveOneToOneAssociation(ass, this.$route.params.id)
            } else {
                await this._saveMultipleAssociation(ass, this.$route.params.id)
            }

            ass.isBeingSaved = false
            ass.isBeingModified = false
        },
        async _saveMultipleAssociation(ass, channelId) {
            const associationNormalized = new BaseChannelBackendAssociation({
                idMuven: ass.getBackendOption().idMuven,
                idExternalChannel: ass.idExternalChannelList[0],
                allowExport: ass.allowExport,
                isActive: ass.isActive,
            })

            try { 
                await this.associationService.associateChannelEntitiesWithBackendEntities([associationNormalized], channelId)
                this.associationCacheControl.remove(this.associationList, ass)

                this.$floatingAlert.hide()
                this.$floatingAlert.success({
                    message: 'Associação atualizada com sucesso!',
                })
            } catch(e) {
                this.$floatingAlert.error({
                    message: e.message,
                })
            }
        },
        async _saveOneToOneAssociation(ass, channelId) {
            ass.isBeingSaved = true

            const assSnapshotBeforeModification = this.associationCacheControl.getAss(ass)

            let backendOption = {} 
            
            // Since the backend needs the idMuven to remove the association
            // we need to make sure we can safely send it back to it.
            // That's why we try to get the ass object that has it somewhere.
            // If it doesn't have on the snapshot of on the ass object,
            // then it never had it in the first place.
            if (ass.getBackendOption().idMuven) {
                backendOption = cloneDeep(ass.backendOption)
            } else if (assSnapshotBeforeModification.getBackendOption().idMuven) {
                backendOption = cloneDeep(assSnapshotBeforeModification.backendOption)
            }

            // Since we can't trust the `ass` object has either `idMuven` or `idExternalChannelList`,
            // then we check if the object has any content by checking if the description exists.
            // If it does, then we use the idExternalChannelList that's in the object. 
            // Otherwise, we just send it as undefined - telling the server to remove the association. 
            const associationNormalized = new BaseChannelBackendAssociation({
                idMuven: backendOption ? backendOption.idMuven : undefined,
                idExternalChannel: ass.hasBackendOption() ? ass.idExternalChannelList[0] : undefined,
                allowExport: ass.allowExport,
                isActive: ass.isActive,
            }) 

            try {
                await this.associationService.associateChannelEntitiesWithBackendEntities([associationNormalized], channelId)
                this.associationCacheControl.remove(this.associationList, ass)

                for (const assItem of this.associationList) {
                    if (assItem.idExternalChannelList === ass.idExternalChannelList) {
                        assItem.backendOption.idMuven = ass.hasBackendOption() ? ass.getBackendOption().idMuven : null
                        // Right, so this is where it gets tricky.
                        // If there was no association done, then the list that came from the backend
                        // will not have the prop `idExternalChannelList`, so, what we can do it, check if
                        // the new association has the backendOption (checking if it wasn't removed),
                        // and, if it has the backendOption, then it uses the `idExternalChannelList` from the
                        // `listChannel` object.
                        // ¯\_(ツ)_/¯  
                        assItem.backendOption.idExternalChannelList = ass.hasBackendOption() ? ass.idExternalChannelList : null
                        assItem.allowExport = ass.allowExport
                        assItem.isActive = ass.isActive
                    }
                }

                const tmpListChannel = cloneDeep(this.listChannel)
                // Get the list from the backend again so it'll have all the updated
                // properties, like `idMuven` and `idExternalChannelList`
                this.listBackend = await this.associationService.getEntitiesInBackend(this.$route.params.id)
                const availableOptions = this._filterListBackendOptions(tmpListChannel, this.listBackend)

                this.associationList = this.listChannel.map((channelInfo) => {
                    return new Association(channelInfo, availableOptions, this.listBackend)
                })

                this.$floatingAlert.hide()
                this.$floatingAlert.success({
                    message: 'Associação atualizada com sucesso!',
                })
            } catch(e) {
                this.$floatingAlert.error({
                    message: e.message,
                })
            }
        },
        _filterListBackendOptions(listChannel = [], listBackend = []) {
            if (!this.oneToOne) {
                return cloneDeep(listBackend)
            }

            for (const backendInfo of listBackend) {
                for (const channelInfo of listChannel) {
                    if (backendInfo.idExternalChannelList.includes(channelInfo.idExternalChannelList[0])) {
                        backendInfo.hasAssociation = true
                        break
                    }
                }
            }

            return listBackend.filter((b) => {
                return !b.hasAssociation
            })
        },
    },
    async mounted() {
        try {
            const channelId = this.$route.params.id
            
            this.channel = await channelService.getChannelById(channelId)            

            this.breadcrumbList = [
                {
                    id: 0,
                    description: 'Canais',
                    path: '/canais'
                },
                {
                    id: 1,
                    description: `Configurações ${this.channel.name}`,
                    channel: this.channel,
                    path: `/canais/${channelId}/configuracoes`,
                },
                {
                    id: 2,
                    description: `Associação de ${this.entityPlural} Muven x ${this.channel.name}`,
                    path: '',
                },
            ];

            // Com busca ao vivo (ML), a lista do canal começa vazia e só é populada quando o usuário
            // busca por um termo (searchInChannel). Nos demais canais, carrega tudo de uma vez.
            this.listBackend = await this.associationService.getEntitiesInBackend(channelId)
            this.listChannel = this.supportsRemoteSearch
                ? []
                : await this.associationService.getEntitiesInChannel(channelId)

            const availableOptions = this._filterListBackendOptions(this.listChannel, this.listBackend)

            this.associationList = this.listChannel.map((channelInfo) => {
                return new Association(channelInfo, availableOptions, this.listBackend)
            })
        } catch (e) {
            this.$floatingAlert.error({
                message: e.message,
            })
        }

        this.loading = false
    },
    computed: {
        // Canais sem listagem completa de categorias (Mercado Livre) fazem a associação por busca
        // ao vivo: em vez de carregar toda a taxonomia, o usuário digita um termo e busca no canal.
        supportsRemoteSearch() {
            return !!this.channel
                && typeof this.channel.isMercadoLivre === 'function'
                && this.channel.isMercadoLivre()
                && this.entityPlural === 'categorias'
        },
        filteredAssociationList() {
            return this.associationList.filter((ass) => {
                const description = this.filterForm.getDescription()

                if (!description) {
                    return ass
                }

                if (ass.description.toLowerCase().indexOf(description) > -1) {
                    return ass
                }

                if (!!ass.getBackendOptionDescription()) {
                    if (ass.getBackendOptionDescription().toLowerCase().indexOf(description) > -1) {
                        return ass
                    }
                }
            })
            .filter((ass) => {
                if (this.filterForm.isActivationStatusAll()) {
                    return ass
                }

                if (this.filterForm.isActivationStatusActive()) {
                    if (ass.isActive === true) {
                        return ass
                    }
                }

                if (this.filterForm.isActivationStatusInactive()) {
                    if (ass.isActive === false) {
                        return ass
                    }
                }
            })
            .filter((ass) => {
                if (this.filterForm.isExportStatusAll()) {
                    return ass
                }

                if (this.filterForm.isExportStatusExportable()) {
                    if (ass.allowExport === true) {
                        return ass
                    }
                }

                if (this.filterForm.isExportStatusNotExportable()) {
                    if (ass.allowExport === false) {
                        return ass
                    }
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.filter-form-container {
    margin-bottom: 15px;

    .btn {
        font-size: .8em;
        min-height: 38px;
    }

    @media(min-width: 1210px) { 
        .btn {
            font-size: 1em;
            min-height: auto;
        }
    }
}

.table {
    input[type="checkbox"] {
        margin: 10px auto 0;
    }
}

.association-actions-container {
    text-align: right;
}
</style>
